export default __webpack_public_path__ + "static/media/equipment-temp.43d74692.JPG";